import { backArrow, exclametry_red_dark, green_tick, green_tick_dark } from '../../../../assets/images';
import React from 'react';
import { Link } from 'react-router-dom';

const ForgotPassword = ({ username, error_msg, setfield, forgot_request, handleForgot }) => {
  return (
    <div className=' mt-16'>
      <Link to='/login'><img src={backArrow} className='mb-4 -ml-6'/></Link>
      <h1 className='text-2xl leading-8 text-gray-900 mb-0 font-bold'>Forgot password?</h1>
      <p className='text-sm text-gray-600 mt-3 mr-20 mb-0 w-96'>
        Please enter your registered email. An email will be sent to the mail with a link to reset your password.
      </p>

      <span className='mb-3 mt-16 text-gray-600 block text-sm font-semibold'>Email address</span>
      <input
        id='input_username'
        type='text'
        name='username'
        placeholder='name@company.com'
        value={username}
        onChange={setfield}
        className={
          'text-base  caret-blue-600 text-gray-700 placeholder-gray-300 leading-4 font-semibold pl-4 border border-gray-200 rounded-md w-96 h-12 bg-gray-100 focus:bg-gray-100 focus:ring-0  focus:outline-none' +
          (!error_msg ? ' focus:border-gray-400' : ' border-red-600')
        }
      />
      {error_msg && <p className='mb-0 mt-2 text-xs font-semibold text-red-600 flex flex-row'><img src={exclametry_red_dark} className='h-3 w-3 mr-1'/>{error_msg}</p>}

      {forgot_request && (
        <div className='mt-8 flex w-96 pr-6 pl-4 py-3 rounded-lg border border-[#D4EEE0]' style={{ color: '#324467', background: '#EFFCF5' }}>
          <img src={green_tick_dark} className='mr-3 mt-1 h-4 w-4' alt='green-tick' />
          <p className='mb-0 text-base '>
            If the email you entered is associated with us, you will receive an email with instructions to reset your password.
          </p>
        </div>
      )}

      {!forgot_request && (
        <button
          onClick={handleForgot}
          className='bg-blue-600 text-white w-96 py-4 rounded-md text-lg mt-16 font-semibold hover:bg-blue-600 focus:outline-none'
        >
          Submit
        </button>
      )}
    </div>
  );
};

export default ForgotPassword;
